import React from 'react'
import PropTypes from 'prop-types'

const ico = '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.1" viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg"> <g fill="none" fill-rule="evenodd"> <g transform="translate(-678 -319)" fill="%23FDBD20"> <g transform="translate(48 295)"> <g transform="translate(597 24)"> <polygon points="37.924 7.0903 35.146 8.551 35.676 5.4572 33.429 3.2662 36.535 2.8148 37.924 0 39.313 2.8148 42.42 3.2662 40.172 5.4572 40.703 8.551"/> </g> </g> </g> </g> </svg>'

const StarsIco = ({ stars, className }) => (
  <div
    className={className}
    style={{
      backgroundRepeat: 'repeat-x',
      backgroundImage: `url('data:image/svg+xml;charset=UTF-8,${ico}')`,
      backgroundSize: '10px 9px',
      height: '9px',
      width: stars && stars !== 0 ? `${stars * 10}px` : '0px',
      display: 'inline-block',
    }}
  />
)

StarsIco.propTypes = {
  stars: PropTypes.number,
  className: PropTypes.string,
}

StarsIco.displayName = 'StarsIco'

export default StarsIco
